import React from 'react';

import * as SidebarConstants from 'sidebar/SidebarConstants';
import SidebarItem from 'sidebar/SidebarItem';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as UnitDictionaryDAO from 'units/UnitDictionaryDAO';

interface UnitDictionarySettingsProps {
  section: SidebarConstants.Section;
}

export default function UnitDictionarySettings({section}: UnitDictionarySettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">Unit dictionary</div>
      <SidebarItem
        active={section === SidebarConstants.Section.UNIT_DICTIONARY}
        icon={<BenchlingIcon className="result-icon" icon="unit" />}
        name="Unit dictionary"
        link={UnitDictionaryDAO.UNIT_DICTIONARY_URL}
      />
    </div>
  );
}
